import Caption from 'LuxKit/Typography/Caption'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import type { ComponentProps, ReactNode } from 'react'
import _PriceRowPrice from '../_PriceRowPrice'
import clsx from 'clsx'
import { defineMessage, useIntl } from 'react-intl'

type InheritedBasePriceRowPriceProps = Pick<ComponentProps<typeof _PriceRowPrice>, 'className' | 'discountPercentage' | 'discountType' | 'saleUnit' | 'signDisplay' | 'size' | 'priceFormat' | 'caption'>

interface Props extends InheritedBasePriceRowPriceProps, Utils.PropsWithDataAttributes {
  /**
   * Main price
   */
  memberPrice: number
  /**
   * Prepend the price with the LuxPlus logo
   */
  logoPlacement?: 'leading' | 'trailing'
}

const trailingLuxPlusMessage = defineMessage({
  id: 'qg18mjM_yahXRtEZVoVD',
  defaultMessage: 'with <luxPlusLogo></luxPlusLogo>',
  description: 'Caption suffix appended after a LuxPlus member price that reads with the LuxPlus logo',
})

const renderLuxPlusLogo = (_chunks: ReactNode) => <LuxPlusLogoWrapper height={8} colour="inherit" />
const trailingLuxPlusMessageValues = { luxPlusLogo: renderLuxPlusLogo }

function PriceRowLuxPlusPrice(props: Props) {
  const {
    memberPrice,
    logoPlacement,
    saleUnit,
    size,
    className,
    ...rest
  } = props
  const intl = useIntl()

  return <_PriceRowPrice
    {...rest}
    className={clsx(className, PriceRowLuxPlusPrice.name)}
    size={size}
    price={memberPrice}
    priceColour="lux-plus"
    saleUnitColour="lux-plus"
    priceLeading={logoPlacement === 'leading' && <><LuxPlusLogoWrapper height={8} />&nbsp;</>}
    saleUnit={saleUnit}
    priceTrailing={logoPlacement === 'trailing' && <Caption
      as="span"
      variant="medium"
      colour="lux-plus"
      weight="normal"
      format="lowercase"
      wrap="no-wrap"
    >
      {intl.formatMessage(trailingLuxPlusMessage, trailingLuxPlusMessageValues)}
    </Caption>}
    wrap={logoPlacement === 'trailing' ? 'word-wrap' : undefined}
  />
}

export default PriceRowLuxPlusPrice
